import { Department } from './../../shared/models/department.model';
export enum ResponseStatus {
  Success = 'SUCCESS',
  Failure = 'FAILURE',
}

export enum ShippingPartner {
  UPS = 'UPS',
  DHL = 'DHL',
}

export enum PaymentMethodEnum {
  RECHNUNG = 'PAYMENT_METHOD_RECHNUNG',
  SEPA = 'PAYMENT_METHOD_SEPA',
  SEPA_MISCH = 'PAYMENT_METHOD_SEPA_MISCH',
  SEPA_EINZEL = 'PAYMENT_METHOD_SEPA_EINZEL',
  NACHNAHME = 'PAYMENT_METHOD_NACHNAHME',
  VORKASSE = 'PAYMENT_METHOD_VORKASSE',
}

export enum IndividualPaymentMethod {
  INDIVIDUAL_SEPA = 'INDIVIDUAL_SEPA',
  SEPA = 'SEPA',
  RECHNUNG = 'RECHNUNG',
}

export enum OrderPaymentStatus {
  open = 'PAYMENT_STATUS_OFFEN',
  paid = 'PAYMENT_STATUS_BEZAHLT',
  overDue = 'PAYMENT_STATUS_MAHNUNG',
  partial = 'PAYMENT_STATUS_TEILZAHLUNG',
  cleared = 'PAYMENT_STATUS_CLEARED',
}

export enum OrderTypeEnum {
  ORDER_ONLINE = 'ORDER_ONLINE',
}

export enum CustomerOrderTypeEnum {
  ORDER_B2C = 'B2C',
  ORDER_B2B = 'B2B',
}

export enum Action {
  SaveCartButton = 'SAVE_CART_BUTTON_CLICKED',
  SaveCartPopup = 'SAVE_CART_POPUP_CONFIRMED',
  SaveCartAfterDeletingMissingProducts = 'SAVE_CART_AFTER_DELETING_MISSING_PRODUCTS',
  SaveCartAfterDeletingProducts = 'SAVE_CART_AFTER_DELETING_PRODUCTS',
  ClearResidentCartPopup = 'CLEAR_RESIDENT_POPUP_CONFIRMED',
  MakeOrderButton = 'MAKE_ORDER_BUTTON_CLICKED',
  TestCustomerCreateOrder = 'TEST_CUSTOMER_CREATE_ORDER',
}

export enum AvailabilityEnum {
  Yes = 'YES',
  No_temporarily = 'NO_TEMPORARILY',
  No_permanently = 'NO_PERMANENTLY',
  No_seasonal = 'NO_SEASONAL',
  Delisted = 'DELISTED',
}

export enum LogLevels {
  error = 'error',
  warning = 'warning',
  info = 'info',
  debug = 'debug',
}

export enum CartDisplay {
  Bag = 'bag',
  Box = 'box',
  BoxStack = 'boxStack',
}

export enum Gender {
  Male = 'MALE',
  Female = 'FEMALE',
  Unisex = 'UNISEX',
  None = 'NONE',
}

export enum UserRole {
  Admin = 'ADMIN',
  Manager = 'MANAGER',
  User = 'USER',
  UserCollectorWithoutWB = 'USER_Collector_without_WB',
  UserOrdererWithoutWB = 'USER_Orderer_without_WB',
  SpyOnly = 'USER_SPY_ONLY',
  Tester = 'USER_Testkunde',
}

export enum UserType {
  Partner = 'PARTNER',
  Customer = 'CUSTOMER',
}

export enum BringLieselRole {
  Editor = 'EDITOR',
}

export enum RTPStatus {
  Ready = 'READY',
  NotReady = 'NOT_READY',
}

export enum PositionInFacility {
  Administration = 'ADMINISTRATION',
  FacilityManagement = 'FACILITY_MANAGEMENT',
  Housekeeping = 'HOUSEKEEPING',
  Internal = 'INTERNAL',
  SocialService = 'SOCIAL_SERVICE',
  NursingManagement = 'NURSING_MANAGEMENT',
  ResidientialManagement = 'RESIDENTIAL_MANAGEMENT',
  Reception = 'RECEPTION',
  RegionalManagement = 'REGIONAL_MANAGEMENT',
  QualityManagement = 'QUALITY_MANAGEMENT',
  Open = 'OPEN',
}

export enum LoginErrorCodes {
  InvalidCredentials = 'INVALID_CREDENTIALS',
  TooManyFails = 'TOO_MANY_FAILS',
  UserBlocked = 'USER_BLOCKED',
  InvalidPassword = 'INVALID_PASSWORD',
  MustLoginWithProvider = 'MUST_LOGIN_WITH_PROVIDER',
}

export enum UserErrorCodes {
  UsernameIsTaken = 'USERNAME_IS_TAKEN',
  EmailIsTaken = 'EMAIL_IS_TAKEN',
}

export enum ForgotPasswordErrorCodes {
  InvalidEmail = 'INVALID_EMAIL',
}

export enum ImageType {
  Resident = 'residents',
  Customer = 'customers',
  User = 'users',
  Department = 'departments',
}

export enum PasswordChangeErrorCodes {
  WrongPassword = 'WRONG_PASSWORD',
}

export type SelectDisplayMode = 'TEXT' | 'ICON' | 'ICON_WITH_TEXT';

export enum TagType {
  Price = 'PRICE',
  Brand = 'BRAND',
  Page = 'PAGE',
}

export enum AdbannerSize {
  Small = 'SMALL',
  Medium = 'MEDIUM',
  Large = 'LARGE',
}

export enum SnackBarType {
  SUCCESS = 'success',
  ERROR = 'error',
}

export enum ShopType {
  Favourites = 'favourites',
  LastOrdered = 'last-ordered',
  SearchResults = 'search-results',
  Category = 'category',
  Promotion = 'promotion',
}

export enum OrderDateFilter {
  All = 'ALL',
  Last12Months = 'LAST_12_MONTH',
}

export type ButtonType = 'SAVE' | 'CANCEL' | 'DELETE' | 'SECOND';

export enum ZeroPriceType {
  None = 'NONE',
  B2B = 'B2B',
  B2C = 'B2C',
  B2B_B2C = 'B2B_B2C',
}

export enum DepositType {
  NONE = 'NONE',
  MEHRWEG_0_15 = 'MEHRWEG_0_15',
  EINWEG_0_25 = 'EINWEG_0_25',
  MEHRWEG_0_08 = 'MEHRWEG_0_08',
}

export enum DownloadIcon {
  Single = 'SINGLE',
  All = 'ALL',
  Blank = 'BLANK',
}

export enum DeactivationReason {
  SelfPayer = 'SELF_PAYER',
  BurstSepa = 'BURST_SEPA',
  OpenInvoice = 'OPEN_INVOICE',
  ConnextUnflagged = 'CONNEXT_UNFLAGGED',
  Other = 'OTHER',
}

export enum MynevaPaymentMethod {
  Lastschrift = 'PAYMENT_METHOD_LASTSCHRIFT',
  Verwahrgeld = 'PAYMENT_METHOD_VERWAHRGELD',
}

export enum MonthlyBudgetResetType {
  BeginningOfMonth = 'BEGINNING_OF_MONTH',
  MiddleOfMonth = 'MIDDLE_OF_MONTH',
}

export enum DepartmentTypeEnum {
  B2C = 'B2C',
  B2B = 'B2B',
}

export enum ListView {
  list = 'list',
  grid = 'grid',
}

export enum ResidentListSort {
  lastName = 'lastName',
  firstName = 'firstName',
  roomNumber = 'roomNumber',
}
